import { useNavigate } from "react-router-dom";
import ViewConnectClientModal from "./ViewConnectClientModal";
import { useState } from "react";
import { useSalesChannelData } from "../../../apis/integrationApis";
import IntegrationSkeleton from "../../../components/skeleton/IntegrationSkeleton";

export default function NewApplication() {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);

  const { data, isSuccess, isPending, refetch, isFetching } =
    useSalesChannelData();

  return (
    <div>
      {/* New Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mb-6">
        {isPending
          ? Array.from({ length: 6 }, (_, idx) => (
              <IntegrationSkeleton key={idx} />
            ))
          : data?.length > 0 &&
            data?.map((channel: any) => {
          return (
            <div
              key={channel?.id}
              className="bg-[#FCFDF8] p-4 rounded-lg flex items-start justify-between gap-4 scale-100 hover:scale-105 transition-all cursor-pointer "
            >
              <div className="flex-shrink-0">
                <img
                  src={channel?.companyLogo}
                  alt={channel?.companyName}
                  className="size-16 rounded-md bg-white"
                />
              </div>

              <div>
                <div className="space-y-1 mb-4">
                  <h1 className="font-medium">{channel?.name}</h1>
                  <p className="text-sm text-gray-600">{channel?.description}</p>
                </div>

                <div className="flex items-center gap-2">
                  <button
                    onClick={() => navigate(`/integration/${channel?.id}`)}
                    className="border px-4 py-1 font-medium text-sm bg-[#FBD037]/20 hover:bg-[#FBD037] border-[#FBD037] text-[#212121] rounded-md transition-all duration-150"
                  >
                    {channel?.status}
                    {/* Connect */}
                  </button>
                  <button
                   onClick={() => setOpen(true)}
                    className="text-sm border-[0.5px] border-[#D2D2D2] text-[#212121] bg-[#D2D2D2]/10 hover:bg-[#D2D2D2]/30 px-4 py-1 rounded-md transition-all duration-150"
                  >
                    {" "}
                    4 Connected
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <ViewConnectClientModal onClose={() => setOpen(false)} open={open} />
    </div>
  );
}
